// GENERATED FILE - DO NOT EDIT BY HAND.
// Source: data/YCP_Location_Territory_Map.csv
// Regenerate: node scripts/gen-scopekey-lookup.js
//
// Resolves craft + railroad + work location to the LCA designation
// that identifies the Local Chairperson with authority over a claim.
// The table is installation content (section 739): src\data\scopeKeyTable.js, exported here as SCOPE_KEY_LOOKUP.
import { SCOPE_KEY_LOOKUP_TABLE } from './scopeKeyTable';

export const SCOPE_KEY_LOOKUP = SCOPE_KEY_LOOKUP_TABLE;

export function resolveScopeKey(craft, railroad, workLocation) {
  if (!craft || !railroad || !workLocation) return String();
  return SCOPE_KEY_LOOKUP[craft + String.fromCharCode(124) + railroad + String.fromCharCode(124) + workLocation] || String();
}
